import * as types from './actionTypes';  
import allOfferingsApi from '../api/allOfferingsApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchAllOfferings() {

  return {
    type: types.DO_FETCH_ALL_OFFERINGS, 
    
  };
}

export function doFetchAllOfferingsRes(data) {  
  return {
    type: types.DO_FETCH_ALL_OFFERINGS_RES, 
    data
  };
}

export function fetchAllOfferings() {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      allOfferingsApi.doFetchAllOfferings().then(data => {
        dispatch(doFetchAllOfferingsRes(data));
        dispatch(doFetchAllOfferingsRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}